import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=13f9e62c&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f9e62c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13f9e62c')) {
      api.createRecord('13f9e62c', component.options)
    } else {
      api.reload('13f9e62c', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=13f9e62c&scoped=true&", function () {
      api.rerender('13f9e62c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4B60lnwoq7AQO/JS/comp/Accordion.vue"
export default component.exports